<template>
  <transition name="pa-simple-fade" @after-enter="handleAfterEnter">
    <div class="pa-message-app-editor" v-if="isVisible">
      <div class="pa-message-app-editor-editor-box" ref="editorBox">
        <div class="editor-set">
          <div class="editor-field">
            <textarea class="textarea" v-on:keydown.prevent.shift.enter="handleSend" v-model="inputMessage"></textarea>
          </div>
          <div class="button-field">
            <button class="button" v-on:click.prevent="handleSend">{{sendButtonText}}</button>
          </div>
        </div>

        <EditorBoxOverlay
          :isOpen="isOpenEditorOverlay"
          :isLoading="isEditorLoading"
          :cancelButtonText="editorOverlayButtonText"
          @onClickClose="handleOverlayClickCancel"
          @onClose="handleOverlayClose"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import EditorBoxOverlay from '@/components/Pages/Office/MessageApp/EditorBoxOverlay.vue'

export default {
  props : {
    placeHolderMessage  : {
      default : ''
    },

    sendButtonText      : {
      default : '発言'
    },

    isVisible           : {
      default : false
    },

    isEditorLoading : {
      default: false
    },

    isOpenEditorOverlay : {
      default : false
    },
    
    editorOverlayButtonText : {
      default: '閉じる'
    },
  },

  components : {
    EditorBoxOverlay
  },

  data(){
    return {
      inputMessage  : ''
    };
  },

  watch : {
    placeHolderMessage : {
      handler(value){
        if(this.inputMessage === ''){
          this.inputMessage = value;
        }
      },
      immediate: true
    },
  },

  methods : {
    handleSend(){
      this.$emit('onSend', this.inputMessage);
    },

    handleOverlayClickCancel(){
      this.$emit('overlayClickCancel');
    },

    handleOverlayClose(){
      // console.log('closed!');
    },

    handleAfterEnter(){
      let editorBoxHeight = 0;
      
      if(typeof this.$refs.editorBox !== 'undefined'){
        editorBoxHeight = this.$refs.editorBox.offsetHeight;
      }

      this.$emit('onVisibled', editorBoxHeight);
    },

    handleResize(){
      if(typeof this.$refs.editorBox === 'undefined') return;

      const editorBoxHeight = this.$refs.editorBox.offsetHeight;
      
      this.$emit('onResize', editorBoxHeight);
    }
  },

  created(){
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy(){
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-message-app-editor{
  &-editor-box{
    width:100%;
    position: absolute;
    left:0;
    bottom:0;
    z-index:1;
    background-color:rgba(145, 61, 96, .95);
    backdrop-filter: blur(10px);

    .editor-set{
      display:flex;
      flex-direction: row;
      width:98%;
      margin-top:.5rem;
      padding:.5rem 0;
      margin:0 auto;
      border-top:2px solid #893658;

      .editor-field{
        width:80%;
        margin:0 auto;
        padding-bottom: env(safe-area-inset-bottom);
        overflow:hidden;

        textarea.textarea{
          box-sizing: border-box;
          min-height:60px;
          border:4px solid #89620C;
          background-color: #DDCEB3;
          padding:6px;
          border-radius: 6px;
          font-size:1rem;

          &:focus{
            box-shadow: none;
          }

          @media screen and (min-width: $desktop) {
            min-height: 80px;
            font-size:1rem;
          }

          @include until(375px) {
            font-size:.9rem;
          }
        }
      }

      .button-field{
        width:20%;
        padding-left:.5rem;
        overflow:hidden;

        button.button{
          box-sizing: border-box;
          border:2px solid #723E14;
          background-color:#874D26;
          color:#e8dfd9;
          font-weight: bold;

          &:focus{
            box-shadow: none;
          }

          @include until(375px) {
            padding:10px;
            font-size:1rem;
          }
        }
      }

      @media screen and (min-width: $desktop) {
        width:780px;
        margin:0 auto;

        .editor-field{
          width:700px;
        }

        .button-field{
          width:80px;

          button.button{
            padding:0 1rem;
          }
        }
      }
    }
  }
}
</style>